export const ADMIN = "ROLE_ADMIN";
